import axios from 'axios'
import Vue from '@src/main.js'
import { getSavedState, saveState } from '@src/utils/localStorage'
import { simpleWarning, requestError } from '@utils/alerts'

const domain = process.env.VUE_APP_URL_API
const language = getSavedState('user.currentLanguage')
    ? getSavedState('user.currentLanguage')
          .match(/.{1,2}/g)
          .join('-')
    : null

export const withHeadersInstance = axios.create({
    baseURL: domain,
    headers: {
        Authorization: `Bearer ${getSavedState('auth.token')}`,
        'Content-Type': 'application/json; charset=utf-8',
        // 'Access-Control-Allow-Origin': '*',
        'Accept-Language': language || 'pt-BR',
    },
})
withHeadersInstance.interceptors.request.use(function (config) {
    Vue.$store.dispatch('base/setLoading', true)
    config.headers.Authorization = `Bearer ${getSavedState('auth.token')}`
    config.headers['Accept-Language'] = language || 'pt-BR'
    return config
})
withHeadersInstance.interceptors.response.use(
    function (response) {
        Vue.$store.dispatch('base/setLoading', false)
        return response
    },
    function (error) {
        Vue.$store.dispatch('base/setLoading', false)
        // alerta de sessão expirada
        if (error.response && error.response.status === 401) {
            Vue.$store.dispatch('base/setLoading', false)

            Vue.$store.dispatch('auth/logOut')
            simpleWarning('sessionExpired')
            Vue.$router.push({
                path: '/login',
            })
            return Promise.reject(error)
        }
        // redireciona para a pagina de erro em caso de get requests
        if (error.response && error.response.config.method === 'get') {
            // guarda o tipo de erro para ser mostrado na tela de erro
            saveState(`errorType`, error.response.status)
            Vue.$router.push({
                path: '/error',
            })
        } else if (error.response) {
            // alerta de erro em caso de post/put
            if (getSavedState('auth.token')) {
                const errorMessage = error.response.data.errors
                    ? error.response.data.errors[0].message
                    : ''
                requestError(errorMessage)
            }
        } else if (!error || !error.response) {
            if (getSavedState('auth.token')) {
                simpleWarning('userError')
            }
        }
        return Promise.reject(error)
    }
)

export const simpleInstance = axios.create({
    baseURL: domain,
    responseType: 'arraybuffer',
})

simpleInstance.interceptors.request.use(function (config) {
    Vue.$store.dispatch('base/setLoading', true)
    config.headers.Authorization = `Bearer ${getSavedState('auth.token')}`
    return config
})
simpleInstance.interceptors.response.use(
    function (response) {
        Vue.$store.dispatch('base/setLoading', false)
        return response
    },
    function (error) {
        Vue.$store.dispatch('base/setLoading', false)
        // redireciona para a pagina de erro em caso de get requests
        if (error.response && error.response.config.method === 'get') {
            // guarda o tipo de erro para ser mostrado na tela de erro
            saveState(`errorType`, error.response.status)
            Vue.$router.push({
                path: '/error',
            })
        } else if (error.response) {
            // alerta de erro em caso de post/put
            requestError(error.response.data.errors[0].message)
        } else if (!error.response) {
            simpleWarning('userError')
        }
        return Promise.reject(error)
    }
)
